<template>
  <v-container fluid tag="section">
    <v-row>
      <v-layout justify-center style="flex-wrap: wrap">
        <v-col md="auto" cols="12" class="d-flex justify-center">
          <v-select v-model="selectedEsercizio" @change="loadData()" :items="listEsercizi" item-text="season"
            item-value="annoCurEse" :menu-props="{ maxHeight: '400' }" :label="$t('accounting_exercise')" required
            color="primary" :hint="$t('pick_accounting_exercise')" persistent-hint></v-select>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-icon color="primary" large v-on="on" style="cursor: pointer" class="mr-2"
                @click.native="loadData()">mdi-refresh</v-icon>
            </template>
            <span>{{ $t("refresh") }}</span>
          </v-tooltip>
        </v-col>
      </v-layout>
    </v-row>
    <v-row v-if="statistiche">
      <v-col md="8" cols="12">
        <v-card class="mx-auto text-center" v-if="statistiche.andamento.length > 0">
          <v-card-text>
            <GChart :resizeDebounce="1000" type="LineChart" :data="entrateUsciteData" :options="entrateUsciteOptions" />
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <div class="display-1">{{ $t("account_balance") }}</div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col md="4" cols="12">
        <v-card class="mx-auto text-center" v-if="statistiche.ripartizioneSaldo.length > 0">
          <v-card-text>
            <GChart :resizeDebounce="1000" type="PieChart" :data="ripartizioneCassaData"
              :options="ripartizioneCassaOptions" />
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text>
            <div class="display-1">{{ $t("account_balance_ripartition") }}</div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="saldoUtenti && saldoUtenti.length > 0">
      <v-col md="2" cols="12" v-for="utente in saldoUtenti" v-bind:key="utente.id">
        <v-card>
          <v-card-title class="justify-center font-weight-light">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="primary" @click="prtEstrattoConto(utente)" icon v-bind="attrs" v-on="on" min-width="0"
                  style="position: absolute; right: 0px">
                  <v-icon large color="primary">mdi-file-pdf-box</v-icon>
                </v-btn>
              </template>
              <span> {{ $t("print_account_balance") }}</span>
            </v-tooltip>
            {{ utente.fullName }}
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-layout column align-center justify-center>
              <v-btn color="primary" @click="emptyCassa(utente.masterId, utente.saldo)" icon>
                <img class="userLogo" :src="utente.avatar" />
              </v-btn>
            </v-layout>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-text class="justify-center">
            <h4 style="text-align: center">{{ utente.saldo }} €</h4>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <edit-cge ref="gestMovimentoDialog" @isUpdated="loadData"></edit-cge>
  </v-container>
</template>

<script>
import { GChart } from "vue-google-charts";
import gestMovimento from "@/app/contab/gestMovimento.vue";

export default {
  name: "statistiche-cge",
  components: { GChart, "edit-cge": gestMovimento },
  props: {},
  data() {
    return {
      statistiche: null,
      saldoUtenti: null,
      listEsercizi: [],
      selectedEsercizio: 0,
      entrateUsciteData: [],
      entrateUsciteOptions: {
        curveType: "function",
        legend: { position: "bottom" },
        height: 500,
        lineWidth: 5,
        series: {
          0: { color: this.$vuetify.theme.themes.light.success },
          1: { color: this.$vuetify.theme.themes.light.error },
          2: { color: this.$vuetify.theme.themes.light.primary },
        },
      },
      ripartizioneCassaData: [],
      ripartizioneCassaOptions: {
        legend: { position: "bottom" },
        height: 500,
      },
    };
  },

  methods: {
    prtEstrattoConto(item) {
      let url =
        "/auth/contab/pdf/estrattoConto/" +
        item.mastrCge +
        "/" +
        item.sotmaCge +
        "/" +
        item.dettaCge;
      this.$documentViewer.documentViewerRsp.docUrl = url;
    },
    loadData() {
      let _ = this;
      let now = new Date();

      // Recupera esercizi
      _.listEsercizi = [];
      _.chiamataAxios("GET", "auth/contab/listEsercizi").then((response) => {
        _.listEsercizi = response.data.listEsercizi;
        if (!_.selectedEsercizio || _.selectedEsercizio === 0)
          _.selectedEsercizio = response.data.curEsercizio.annoCurEse;
      });

      // Recupera saldo utenti
      _.saldoUtenti = [];
      _.chiamataAxios(
        "GET",
        "auth/contab/listUserSaldo/" + _.selectedEsercizio
      ).then((response) => {
        _.saldoUtenti = response.data;
      });

      _.statistiche = null;
      _.isFetching = true;
      _.chiamataAxios(
        "GET",
        "auth/contab/statistiche/" + _.selectedEsercizio
      ).then((response) => {
        // Customize response
        _.statistiche = response.data;

        // Carica dati
        _.entrateUsciteData = [
          [
            _.$t("period"),
            _.$t("reg_entry_p"),
            _.$t("reg_exit_p"),
            _.$t("account_balance"),
          ],
        ];
        _.statistiche.andamento.forEach((andamento) => {
          _.entrateUsciteData.push([
            andamento.periodo,
            andamento.entrate,
            andamento.uscite,
            andamento.saldo,
          ]);
        });

        _.ripartizioneCassaData = [["cassa", "importo"]];
        _.statistiche.ripartizioneSaldo.forEach((ripartizione) => {
          _.ripartizioneCassaData.push([
            ripartizione.key,
            Math.abs(ripartizione.value),
          ]);
        });
        _.isFetching = false;
      });
    },
    emptyCassa(masterId, importo) {
      this.$refs.gestMovimentoDialog.scaricoCassa(masterId, importo);
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>
<style scoped>
.userLogo {
  max-height: 50px;
  max-width: 500px;
  width: auto;
  height: auto;
}
</style>